import { ContentGroupDetailDialogDataViewModel } from './content-group-detail-dialog-data.view-model';

export enum ContentGroupDetailDialogVariant {
  NEW,
  EDIT,
}

export interface ContentGroupDetailDialogModalViewModel {
  variant: ContentGroupDetailDialogVariant;
  data?: ContentGroupDetailDialogDataViewModel;
}
